import Vue from 'vue'
import VueMask from 'v-mask'

// v-mask
Vue.use(VueMask)
